import {
    LOAD_JOB,
    LOAD_JOB_FAILURE,
    LOAD_JOB_SUCCESS,
    JOB_INVITATIONS,
    JOB_INVITATIONS_SUCCESS,
    JOB_INVITATIONS_FAILURE,
} from '../actions';
import { UPDATE_BOOKING_FIELD } from '../actions/Bookings';

const initialState = {
    fetching: false,
    error: undefined,
    content: undefined,
    meta: {
        count: 0,
        previous: null,
        next: null,
        status_code: undefined,
    },
    invitations: {
        fetching: false,
        error: undefined,
        content: undefined,
    },
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_JOB:
            return {
                ...state,
                error: undefined,
                fetching: true,
                invitations: {
                    fetching: false,
                    error: undefined,
                    content: undefined,
                },
            };
        case LOAD_JOB_FAILURE:
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        case LOAD_JOB_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: undefined,
                content: action.payload.content,
                meta: action.payload.meta,
            };
        case JOB_INVITATIONS:
            return {
                ...state,
                invitations: {
                    fetching: true,
                    error: undefined,
                    content: undefined,
                },
            };
        case JOB_INVITATIONS_SUCCESS:
            return {
                ...state,
                invitations: {
                    fetching: false,
                    error: undefined,
                    content: action.payload.content,
                },
            };
        case JOB_INVITATIONS_FAILURE:
            return {
                ...state,
                invitations: {
                    fetching: false,
                    error: action.payload.content,
                    content: undefined,
                },
            };
        case UPDATE_BOOKING_FIELD:
            return {
                ...state,
                content:
                    state.content &&
                    // eslint-disable-next-line no-bitwise
                    (state.content.id === action.payload.jobId) &
                        state.content.booking &&
                    state.content.booking.id === action.payload.id
                        ? {
                              ...state.content,
                              ...action.payload.data,
                          }
                        : state.content,
            };
        default:
            return state;
    }
};

export default reducer;
